import { getCSRFTokenAndSetCookie, ValidatedUrl__get_Value, UrlKind, ValidatedUrlModule_create } from "../HttpV2.js";
import { toConsole, printf, toFail } from "../fable_modules/fable-library.3.7.20/String.js";
import { singleton } from "../fable_modules/fable-library.3.7.20/AsyncBuilder.js";
import { toString } from "../fable_modules/fable-library.3.7.20/Types.js";
import { HttpRequest__SetHeader_Z384F8060 } from "../fable_modules/Fenix.Dry.Fable.60.0.3/Http2.fs.js";
import { SveaDry_Dependency } from "./Library.js";

export const fenixWebUrl = (() => {
    const _arg = ValidatedUrlModule_create(new UrlKind(0, "/"));
    return (_arg.tag === 1) ? toFail(printf("err: %s"))(_arg.fields[0]) : _arg.fields[0];
})();

export const dep = new SveaDry_Dependency(ValidatedUrl__get_Value(fenixWebUrl), (x) => singleton.Delay(() => singleton.Bind(getCSRFTokenAndSetCookie(), (_arg) => {
    let token;
    const _arg_1 = _arg;
    token = ((_arg_1.tag === 1) ? toFail(printf("Could not get CSRF token")) : _arg_1.fields[0]);
    const arg = toString(x.Url);
    toConsole(printf("HTTP Request: %s"))(arg);
    return singleton.Return(HttpRequest__SetHeader_Z384F8060(HttpRequest__SetHeader_Z384F8060(x, "X-CSRF-Token", token.csrfToken), "client-reference", "FenixWeb-ApiClient"));
})), (req, resp) => {
    const arg_1 = toString(req.Url);
    toConsole(printf("HTTP Request Complete: %s"))(arg_1);
    return singleton.Delay(() => singleton.Return(resp));
});

export const fenixApiUrl = (() => {
    const _arg = ValidatedUrlModule_create(new UrlKind(1, "/"));
    return (_arg.tag === 1) ? toFail(printf("err: %s"))(_arg.fields[0]) : _arg.fields[0];
})();

export const fenixApiDep = new SveaDry_Dependency(ValidatedUrl__get_Value(fenixApiUrl), (x) => singleton.Delay(() => {
    const arg = toString(x.Url);
    toConsole(printf("HTTP Request: %s"))(arg);
    return singleton.Return(HttpRequest__SetHeader_Z384F8060(x, "client-reference", "FenixWeb-ApiClient"));
}), (req, resp) => {
    const arg_1 = toString(req.Url);
    toConsole(printf("HTTP Request Complete: %s"))(arg_1);
    return singleton.Delay(() => singleton.Return(resp));
});

